export class Team {
  static createFlippedStatePredicate(state) {
    /** @param {Team} team */
    const predicate = team => team.flippedState === state
    return predicate
  }
}
